import { useGetUserInfoQuery } from "@blox/api/index";
import { selectUserId } from "@blox/shared/selectors/userSelectors";

import { useFirestore } from "./useFirestore";
import { useIsLoggedIn } from "./useIsLoggedIn";

export function useBloxPlusIsEnabled() {
  const isLoggedIn = useIsLoggedIn();
  const { data: userId } = useGetUserInfoQuery({
    query: { select: selectUserId, enabled: isLoggedIn },
  });
  const bloxPlusEnabled = useFirestore((s) => s.config.features.bloxPlusEnabled);
  const bloxPlusUserIds = useFirestore((s) => s.config.features.bloxPlusUserIds);
  return bloxPlusEnabled || (bloxPlusUserIds.length && bloxPlusUserIds.includes(userId ?? ""));
}
